import * as React from 'react';
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
import InputMask from 'react-input-mask';
import { MaskedTextBox } from '@progress/kendo-react-inputs';

export interface ISystemInputMaskBox  {
    mask: string | undefined
}

/**
 * Creates an Input with Label
 * */

export default class SystemInputMaskBox extends SystemBase<ISystemInputMaskBox>
{
    constructor(props: any) {
        super(props);
    }

    // pass on the onChange event to parent
    public handleChange = (event: any) => {
        this.setState({
            value: event.target.value, rawValue: event.target.rawValue, isValid: this.validate(event.target.rawValue), isDirty: true /*can be improved  */
        });

        if (this.props.onChange)
            this.props.onChange(event, event.target.name, event.target.value);
    }

    // handle the input exit
    public handleBlur = (event: any) => {

        let valid = this.validate(this.state.rawValue)
        this.setState({ inFocus: false, isValid: valid });
        if (this.props.onValidate) this.props.onValidate(valid);
    }

    render() {
        return (
            <this.WrapperDiv>
                <MaskedTextBox
                    id={this.props.id}
                    name={this.props.name}
                    className="form-control"
                    disabled={this.props.disabled}
                    mask={this.props.mask || ''}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    value={this.state.value || ''}
                />

                {/*<InputMask id={this.props.id} name={this.props.name} className="form-control" disabled={this.props.disabled} mask={this.props.mask}*/}
                {/*    onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur} maskPlaceholder={null} alwaysShowMask={true}*/}
                {/*    value={this.state.value as string | number | string[] | undefined}*/}
                {/*/>*/}
           
            </this.WrapperDiv>
        );
    }   
}
